/**
 * Public contract: renaming it breaks the app's binding in
 * `app/components/footer-privacy-choices/` (and any tag rule later bound to it).
 * Its own module so a client file can import it without the server footer.
 */
export const PRIVACY_TRIGGER_ID = "footer-privacy-choices";
